import { render, staticRenderFns } from "./ProdictItemModal.vue?vue&type=template&id=3b2cf819"
import script from "./ProdictItemModal.vue?vue&type=script&lang=js"
export * from "./ProdictItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports